// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"8e4a58eb","625":"25da1b84"}[chunkId] + ".css";
};